"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _reactMarkdown = _interopRequireDefault(require("react-markdown"));
var _TwelveColumnGrid = _interopRequireDefault(require("../../components/Grid/TwelveColumnGrid/TwelveColumnGrid"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Heading = _interopRequireDefault(require("../../elements/Heading/Heading"));
var _Callout = _interopRequireDefault(require("../../elements/Callout/Callout"));
var _excluded = ["className", "children"],
  _excluded2 = ["className", "children"],
  _excluded3 = ["className", "children"],
  _excluded4 = ["className", "children"],
  _excluded5 = ["headingCopy", "impactCopy", "children"],
  _excluded6 = ["node"],
  _excluded7 = ["node"],
  _excluded8 = ["node"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
var StyledSingleColumnImpact = (0, _styledComponents.default)(_TwelveColumnGrid.default)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  text-align: center;\n  padding-bottom: 32.5px; \n  padding-top: 32.5px;\n  background-image: url('https://best-fit.app/static/triangle-grey-25777a8336e851acd1255a9ef785a027.svg');\n  background-color: var(--bf-core-pink);\n  color: #FFFFFF;\n  img {\n    opacity: 70%;\n  }\n"])));
var SingleColumn = (0, _styledComponents.default)(function (_ref) {
  var className = _ref.className,
    children = _ref.children,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return _react.default.createElement(_TwelveColumnGrid.default.Item, Object.assign({
    xs: 10,
    className: className
  }, props), children);
})(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  width: 100%;\n"])));
var MarkdownHeading = (0, _styledComponents.default)(function (_ref2) {
  var className = _ref2.className,
    children = _ref2.children,
    props = (0, _objectWithoutProperties2.default)(_ref2, _excluded2);
  return _react.default.createElement(SingleColumn, Object.assign({
    className: className
  }, props), _react.default.createElement(_Heading.default, {
    h1: true
  }, " ", children, " "));
})(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n"])));
var MarkdownSubheading = (0, _styledComponents.default)(function (_ref3) {
  var className = _ref3.className,
    children = _ref3.children,
    props = (0, _objectWithoutProperties2.default)(_ref3, _excluded3);
  return _react.default.createElement(SingleColumn, Object.assign({
    className: className
  }, props), _react.default.createElement(_Heading.default, {
    h3: true,
    special: true
  }, " ", children, " "));
})(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n"])));
var MarkdownCallout = (0, _styledComponents.default)(function (_ref4) {
  var className = _ref4.className,
    children = _ref4.children,
    props = (0, _objectWithoutProperties2.default)(_ref4, _excluded4);
  return _react.default.createElement(SingleColumn, Object.assign({
    className: className
  }, props), _react.default.createElement(_Callout.default, {
    medium: true
  }, " ", children, " "));
})(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n"])));
var SingleColumnImpact = function SingleColumnImpact(_ref5) {
  var headingCopy = _ref5.headingCopy,
    impactCopy = _ref5.impactCopy,
    children = _ref5.children,
    props = (0, _objectWithoutProperties2.default)(_ref5, _excluded5);
  return _react.default.createElement(StyledSingleColumnImpact, Object.assign({
    justifyContent: 'center',
    spansFullPage: true
  }, props), _react.default.createElement(_reactMarkdown.default, {
    children: impactCopy,
    components: {
      h1: function h1(_ref6) {
        var node = _ref6.node,
          props = (0, _objectWithoutProperties2.default)(_ref6, _excluded6);
        return _react.default.createElement(MarkdownHeading, props);
      },
      h2: function h2(_ref7) {
        var node = _ref7.node,
          props = (0, _objectWithoutProperties2.default)(_ref7, _excluded7);
        return _react.default.createElement(MarkdownCallout, props);
      },
      h3: function h3(_ref8) {
        var node = _ref8.node,
          props = (0, _objectWithoutProperties2.default)(_ref8, _excluded8);
        return _react.default.createElement(MarkdownSubheading, props);
      }
    }
  }));
};
SingleColumnImpact.Column = SingleColumn;
var _default = SingleColumnImpact;
exports.default = _default;